import React, {useState, useEffect, useContext, useRef} from "react";
import LinkRow from '../administration/components/LinkRow';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import CircularProgress from '@material-ui/core/CircularProgress';
import {functions} from "../../constants/common-functions";
import {NO_STRINGIFY} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {SYSTEM_ROLE_SUPERADMIN} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import * as adminStyles from "./components/AdminStyles";

export default function AdministrationHome(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	
	const TIMETABLE_UPLOAD_LECTURES = "TIMETABLE_UPLOAD_LECTURES";
	const TIMETABLE_UPLOAD_EXAMS = "TIMETABLE_UPLOAD_EXAMS";
	
	const [displayProgress, setDisplayProgress] = useState("none");
	const [displayUploadPopup, setDisplayUploadPopup] = useState("none");
	const [displayPasswordPopup, setDisplayPasswordPopup] = useState("none");
	const [displayUploadTimetablePopup, setDisplayUploadTimetablePopup] = useState("none");
	const [adminSections, setAdminSections] = useState([]);
	const [timetableUploadType, setTimetableUploadType] = useState(TIMETABLE_UPLOAD_LECTURES);
	
	const uploadFileInput = useRef(null);
	const uploadTimetableFileInput = useRef(null);
	const password = useRef(null);
	const passwordEncrypt = useRef(null);
		
	useEffect(() => {
		try{
			if(globalState.state.loggedIn.roles.includes(SYSTEM_ROLE_SUPERADMIN)){
				setAdminSections([
					{id:"-4", title:"Organisations", description:"Manage departments, teams, directorates etc", clickFunction:handleClickOrganisations},
					{id:"-3", title:"Floor Zones", description:"Manage floor zones and allocate rooms/spaces", clickFunction:handleClickFloorZones},
					{id:"-2", title:"Resource Directories", description:"Manage resource directory structure", clickFunction:handleClickResourceDirectories},
					{id:"-1", title:"Resource Revisions", description:"Manage resource revisions", clickFunction:handleClickResourceRevisions},
					{id:"0", title:"Properties", description:"Manage sites, campus, malls, buildings, stores etc", clickFunction:handleClickFacilities},
					{id:"1", title:"Geography", description:"Manage regions, countries, locations etc", clickFunction:handleClickGeography},
					{id:"2", title:"Classifications", description:"Manage classifications", clickFunction:handleClickClassifications},
					{id:"6", title:"Space Types", description:"Manage classifications for floors (space type, division etc)", clickFunction:handleClickSpaceTypes},
					{id:"3", title:"Resources", description:"Manage drawings, pdfs in the resource library", clickFunction:handleClickResources},
					{id:"4", title:"Users", description:"Manage users and access control", clickFunction:handleClickUsers},
					{id:"5", title:"Site/Campus SVG", description:"Manage building hotspots on campus/sites", clickFunction:handleClickSvg},
					{id:"6", title:"Home Resources", description:"Manage home page resources and icons", clickFunction:handleClickHomeResources},
					{id:"8", title:"System Look And Feel", description:"Manage background, logos and strap lines for this client", clickFunction:handleClickClient},
					{id:"9", title:"Client Commercials", description:"Manage contacts, contract expiry, scan limits etc", clickFunction:handleClickClientCommercial},
					{id:"10", title:"Photo Tour Zip Files", description:"Access uploaded ZIP files of photos for tours.", clickFunction:handleClickPhotoTourZips},
					{id:"11", title:"Import Utilities", description:"Upload Excel files for utilisation, timwetabling etc ", clickFunction:handleClickAdminImport},
					{id:"12", title:"Publish Views", description:"Publish all views and summaries ", clickFunction:handleClickAdminPublish},
					{id:"13", title:"Spreadsheet Updaters", description:"Use spreadsheets to update various data points ", clickFunction:handleClickBulkUpdater},
					{id:"14", title:"Home Dashboard Configuration", description:"Configure display and navigation for home page", clickFunction:handleClickHomeConfiguration},
					{id:"15", title:"Content Management", description:"Manage the Eva Portal and Other CLient Websites", clickFunction:handleClickCms}
				]);
			}
			else{
				setAdminSections([
					{id:"0", title:"Properties", description:"Manage sites, campus, malls, buildings, stores etc", clickFunction:handleClickFacilities},
					{id:"1", title:"Geography", description:"Manage regions, countries, locations etc", clickFunction:handleClickGeography},
					{id:"2", title:"Classifications", description:"Manage classifications", clickFunction:handleClickClassifications},
					{id:"6", title:"Space Types", description:"Manage classifications for floors (space type, division etc)", clickFunction:handleClickSpaceTypes},
					{id:"3", title:"Resources", description:"Manage drawings, pdfs in the resource library", clickFunction:handleClickResources},
					{id:"4", title:"Users", description:"Manage users and access control", clickFunction:handleClickUsers},
					{id:"6", title:"Home Resources", description:"Manage home page resources and icons", clickFunction:handleClickHomeResources}
				]);
			}
		}
		catch(e){}
	}, []);
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		height:"200vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px",
		
	};
	
	
	
	const buttonContainer = {
		display:"flex",
		marginRight:"20px"
	};
	
	
	
	const textInput = {
		display:"flex",
		width:"200px",
		height:"30px",
		border:'1px solid lightgrey',
		marginLeft:"20px",
		color:'black',
		paddingLeft:"10px"
	};
	
	const linkPanel = {
		display:"flex",
		width:"calc(100% - 80px)",
		marginLeft:"40px",
		flexDirection:"column"
	};
	
	const handleClickFacilities = () => {
		history.push('/administrationproperties');
	};
	
	const handleClickAdminImport = () => {
			history.push('/adminimportscreen');
		};
		
		
	const handleClickAdminPublish = () => {
		history.push('/administrationpublisher');
	};
	
	const handleClickFloorZones = () => {
		history.push('/administrationfloorzones');
	};
	
	const handleClickOrganisations = () => {
		history.push('/administrationorganisations');
	};
				
	const handleClickResourceDirectories = () => {
		history.push('/admin/resourcedirectories/list');
	};
	
	const handleClickResourceRevisions = () => {
		history.push('/admin/resourcerevisions/list');
	};
	
	const handleClickGeography = () => {
		history.push('/administrationgeographies');
	};
	
	const handleClickClassifications = () => {
		history.push('/administrationclassifications');
	};
	
	const handleClickResources = () => {
		history.push('/administrationresources');
	};
	
	
	const handleClickBulkUpdater = () => {
			history.push('/administrationbulkupdater');
		};
	
	const handleClickUsers = () => {
		history.push('/administrationusers');
	};
	
	const handleClickSvg = () => {
		history.push('/administrationsvg');
	};
	
	const handleClickUploadBuildingPhotos = () => {
		history.push('/administrationuploadbuildingphotos');
	};
	
	const handleClickSpaceTypes = () => {
		history.push('/administrationspacetypes');
	};
	
	const handleClickHomeResources = () => {
		history.push('/administrationhomeresources');
	};
	
	const handleClickClient = () => {
		history.push('/administrationclient');
	};
	
	const handleClickClientCommercial = () => {
		history.push('/administrationclientcommercial');
	};
	
	const handleClickPhotoTourZips = () => {
		history.push('/administrationphototourzips');
	};
	
	const handleClickHomeConfiguration = () => {
			history.push('/administrationhomeconfiguration');
		};
	
	const goFloorPlan = () => {
		history.push('/uploadfloorplanpdf');
	};
	
	const handleClickCms= () => {
			history.push('/cms/admin/cmsentry');
		};
	
	const adminSectionDisplay = adminSections.map((item, index) => 
		<LinkRow
			index={index}
			id={item.id}
			title={item.title}
			description={item.description}
			clickFunction={item.clickFunction}
			isBig="YES"
		/>
	);
	
	const hideProgress = () => {
		setDisplayProgress("none");
	};
	
	const goUploadPopup = () => {
		setDisplayUploadPopup("flex");
	};
	
	const goUploadTimetablePopup = () => {
		setDisplayUploadTimetablePopup("flex");
	};
	
	const goPasswordPopup = () => {
		setDisplayPasswordPopup("flex");
	};
	
	const saveEnd = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const handleSubmitError = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const goUpload = () => {
		setDisplayUploadPopup("none");
		setDisplayProgress("flex");
		let formData = new FormData();
			formData.append("file", uploadFileInput.current.files[0]);
			
			functions.submitAjax("/resolution/spreadsheetuploadallvoyansi", 
				formData, saveEnd, NO_STRINGIFY, handleSubmitError);
	};
	
	const goPasswordEncrypt = () => {
		let formData = new FormData();
			formData.append("toencode", password.current.value);	
		functions.submitAjax("/resolutionsoftwareplatform/administration/upload/encodepassword", 
				formData, handleEncrypt, NO_STRINGIFY, handleSubmitError);
	};
	
	const handleEncrypt = (obj) => {
		
		if(obj.hash){
			passwordEncrypt.current.value = obj.hash;
		}
	}
	
	const goUploadTimetable = () => {
		setDisplayUploadTimetablePopup("none");
		setDisplayProgress("flex");
		let formData = new FormData();
			formData.append("file", uploadTimetableFileInput.current.files[0]);
			
			let url = "/resolutionsoftwareplatform/administration/upload/timetable";
			
			if(timetableUploadType === TIMETABLE_UPLOAD_EXAMS){
				url = "/resolutionsoftwareplatform/administration/upload/timetableexams";
			}
			
			functions.submitAjax(url, 
				formData, saveEnd, NO_STRINGIFY, handleSubmitError);
	};
	
	const goProcessTimetable = () => {
		setDisplayUploadTimetablePopup("none");
		setDisplayProgress("flex");
		
			functions.submitAjax("/resolutionsoftwareplatform/administration/upload/timetableprocess", 
				{}, saveEnd, NO_STRINGIFY, handleSubmitError);
	};
	
	const goDownload = () => {
		
	};
	
	
	const progressContainer = {
		display:displayProgress,
		width:"100%",
		height:"calc(100vh - 0px)",
		backgroundColor:"white",
		flexDirection:"column",
		zIndex:"2000",
		color:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		position:"fixed",
		top:"0px",
		left:"0px"
	};
	
	
	const uploadPopup = {
		display:displayUploadPopup,
		position:"fixed",
		top:"130px",
		right:"200px",
		width:"400px",
		backgroundColor:"white",
		minHeight:"50px",
		flexDirection:"column",
		boxShadow: '0 6px 3px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)'
	};
	
	const uploadTimetablePopup = {
		display:displayUploadTimetablePopup,
		position:"fixed",
		top:"130px",
		right:"200px",
		width:"400px",
		backgroundColor:"white",
		minHeight:"50px",
		flexDirection:"column",
		boxShadow: '0 6px 3px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)'
	};
	
	const passwordPopup = {
		display:displayPasswordPopup,
		position:"fixed",
		top:"130px",
		right:"200px",
		width:"400px",
		backgroundColor:"white",
		minHeight:"50px",
		flexDirection:"column",
		boxShadow: '0 6px 3px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)'
	};
	
	const uploadTitle = {
		display:"flex",
		height:"40px",
		alignItems:"center",
		marginLeft:"20px",
		fontSize:"14px",
		color:"black"
	};
	
	const fileInput = {
		display:"flex",
		marginLeft:"20px"
	};
	
	const buttonBar = {
		display:"flex",
		alignSelf:"center",
		margin:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"110px",
		backgroundColor:DEFAULT_BLUE,
		color:"white",
		height:"20px",
		fontSize:"12px",
		alignItems:"center",
		justifyContent:"space-around",
		borderRadius:"4px",
		cursor:"pointer",
		margin:"3px"
	};
	
	const goCancel = () => {
		setDisplayUploadPopup("none");
		setDisplayUploadTimetablePopup("none");
	};
	
	const goQuestionnaire = () => {
		history.push('/workflow/configuration/responses');
	};
	
	const goDocumentTypes = () => {
			history.push('/admin/documenttypes/list');
		};

	return (
	
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={adminStyles.administrationHeader}>
					Administration & Configuration
					<div style={buttonContainer}>
						<div style={adminStyles.menuButton} onClick={goFloorPlan}>
							Floor Plan (Hotspots)
						</div>
						<div style={adminStyles.menuButton} onClick={goDownload}>
							Download
						</div>
						<div style={adminStyles.menuButton} onClick={goUploadPopup}>
							Upload
						</div>
						<div style={adminStyles.menuButton} onClick={goUploadTimetablePopup}>
							Upload Timetable
						</div>
						<div style={adminStyles.menuButton} onClick={goPasswordPopup}>
							Encode Password
						</div>
					</div>
				</div>
				<div style={linkPanel}>
				<LinkRow
					index="-1"
					id="-1"
					title="Questionnaires & Workflow"
					description="View questionnaire responses and scores and configuer workflow and scheduling"
					clickFunction={goQuestionnaire}
					isBig="YES"
				/>
				<LinkRow
					index="-1"
					id="-1"
					title="Document Types & Library"
					description="Manage drawing types and create and remove documents.  Also access control"
					clickFunction={goDocumentTypes}
					isBig="YES"
				/>
				{adminSectionDisplay}
				</div>
				<div style={progressContainer}>
					<CircularProgress
							color="inherit"
						>
						</CircularProgress>
				</div>
				<div style={uploadPopup}>
					<div style={uploadTitle}>
						Upload a spreadsheet:
					</div>
					<input type="file" style={fileInput} ref={uploadFileInput}/>
					<div style={buttonBar}>
						<div style={blueButton} onClick={goUpload}>
							Upload
						</div>
						<div style={blueButton} onClick={goCancel}>
							Cancel
						</div>
					</div>
				</div>
				<div style={uploadTimetablePopup}>
					<div style={{ marginTop:'10px', marginLeft:"20px", marginBottom:"0px", textAlign: "left", fontSize:'12px' }}>
				    <label style={{ marginRight: "15px" }}>
				      <input
				        type="radio"
				        name="timetableType"
				        value={TIMETABLE_UPLOAD_LECTURES}
				        defaultChecked
				        onChange={(e) => setTimetableUploadType(e.target.value)}
				        style={{ marginRight: "5px" }}
				      />
				      Lectures
				    </label>
				    <label>
				      <input
				        type="radio"
				        name="timetableType"
				        value={TIMETABLE_UPLOAD_EXAMS}
				        onChange={(e) => setTimetableUploadType(e.target.value)}
				        style={{ marginRight: "5px" }}
				      />
				      Exams
				    </label>
				  </div>
					<div style={uploadTitle}>
						Upload timetable spreadsheet:
					</div>
					<input type="file" style={fileInput} ref={uploadTimetableFileInput}/>
					<div style={buttonBar}>
						<div style={blueButton} onClick={goUploadTimetable}>
							Upload
						</div>
						<div style={blueButton} onClick={goProcessTimetable}>
							Process
						</div>
						<div style={blueButton} onClick={goCancel}>
							Cancel
						</div>
					</div>
				</div>
				
				<div style={passwordPopup}>
					<div style={uploadTitle}>
						Enter a password:
					</div>
					<input type="text" style={textInput} ref={password}/>
					<div style={uploadTitle}>
						Encoded:
					</div>
					<input type="text" style={{...textInput, width:'350px'}} ref={passwordEncrypt}/>
					<div style={buttonBar}>
						<div style={blueButton} onClick={goPasswordEncrypt}>
							Encode
						</div>
						<div style={blueButton} onClick={goCancel}>
							Cancel
						</div>
					</div>
				</div>
				
			</div>
			
	
	);
}